var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ECG_CHANNELS } from '../constants';
var CELL_SIZE_GAP = 5;
var SAMPLE_SIZE = 0.04;
export var CANVAS_DEFAULT_VALUES = {
    //GRID:
    CELL_WIDTH: 0.1,
    CELL_SIZE: 4,
    BLOCK_WIDTH: 0.3,
    BLOCK_SIZE: 4 * 5,
    //ROWS and COLUMNS canvas separation I, II, III, aVR, aVL, aVF, V1, V2, V3, V4, V5, V6
    ROWS: 6,
    HEIGTH_AMPLITUDE_GIRD_RELATION: 4 / 5,
    COLUMNS: 2,
    columnsText: [
        [ECG_CHANNELS.I, ECG_CHANNELS.II, ECG_CHANNELS.III, ECG_CHANNELS.aVR, ECG_CHANNELS.aVL, ECG_CHANNELS.aVF],
        [ECG_CHANNELS.V1, ECG_CHANNELS.V2, ECG_CHANNELS.V3, ECG_CHANNELS.V4, ECG_CHANNELS.V5, ECG_CHANNELS.V6], // Colum 2
    ],
    //LINE ECG:
    CURVE_WIDTH: 1.5,
    SAMPLING_RATE: 125,
    FREQUENCY: 250,
    TIME: 0.25,
    AMPLITUDE: 0.1,
    //DESING:
    GRID_COLOR: '#F08080',
    LINE_COLOR: '#000033',
    BACKGROUND_COLOR: '#F9F8F2',
    HEIGHT_USER_INFO: 100,
    FULL_WIDTH: false,
};
/**
 * Generic class canvas.
 */
var GenericCanvasClass = /** @class */ (function () {
    /**
     * Constructor.
     * @param id_canvas ID Canvas view.
     * @param dataMg data Dicom.
     */
    function GenericCanvasClass(id_canvas, dataMg) {
        //Configuration:
        this.configuration = __assign({}, CANVAS_DEFAULT_VALUES);
        this.dataMg = dataMg;
        //Canvas ECG:
        this.canvas = document.getElementById(id_canvas);
        this.context = this.canvas.getContext('2d');
        //Canvas resize:
        var canvasHasWidth = Boolean(this.canvas.width);
        var canvasHasHeight = Boolean(this.canvas.height);
        this.canvas.width = canvasHasWidth ? this.canvas.width : window.innerWidth;
        this.canvas.height = canvasHasHeight ? this.canvas.height : window.innerHeight;
        this.canvas.style.width = '100%';
        this.canvas.style.height = '100%';
        //Color canvas:
        this.canvas.style.backgroundColor = this.configuration.BACKGROUND_COLOR;
        //Block size:
        this.configuration.BLOCK_SIZE = this.configuration.CELL_SIZE * CELL_SIZE_GAP;
        //Frequency data dcm:
        this.configuration.FREQUENCY = dataMg.samplingFrequency;
    }
    /**
     * Draw a line from point (x1, y1) to point (x2, y2)
     * @param x1 moveTo(x1).
     * @param y1 moveTo(y1).
     * @param x2 lineTo(x2).
     * @param y2 lineTo(y2).
     */
    GenericCanvasClass.prototype.drawLine = function (x1, y1, x2, y2) {
        this.context.moveTo(x1, y1);
        this.context.lineTo(x2, y2);
    };
    Object.defineProperty(GenericCanvasClass.prototype, "cellSize", {
        //GET Methods:
        /**
         * Returns the cell size
         * @return the cell size
         */
        get: function () {
            return this.configuration.CELL_SIZE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GenericCanvasClass.prototype, "blockSize", {
        /**
         * Returns the block size
         * @return the block size
         */
        get: function () {
            return 5 * this.configuration.CELL_SIZE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GenericCanvasClass.prototype, "cellsPerPeriod", {
        /**
         * Returns the number of cells per period
         * @return the number of cells per period
         */
        get: function () {
            return Math.floor(this.width / this.cellSize);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GenericCanvasClass.prototype, "samplesPerCell", {
        /**
         * Returns the number of samples per cell
         * @return the number of samples per cell
         */
        get: function () {
            return SAMPLE_SIZE * this.samplingRate;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GenericCanvasClass.prototype, "samplingRate", {
        /**
         * Returns the number of samples per second
         * @return the number of samples per second
         */
        get: function () {
            return this.configuration.SAMPLING_RATE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GenericCanvasClass.prototype, "samplesPerPeriod", {
        /**
         * Returns the number of samples per period
         * @return the number of samples per period
         */
        get: function () {
            return Math.floor(SAMPLE_SIZE * this.samplingRate * (this.width / this.cellSize));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GenericCanvasClass.prototype, "width", {
        /**
         * Returns the width of this electrocardiogram
         * @return the width of this electrocardiogram
         */
        get: function () {
            return this.context.canvas.width;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GenericCanvasClass.prototype, "height", {
        /**
         * Returns the height of this electrocardiogram
         * @return the height of this electrocardiogram
         */
        get: function () {
            return this.context.canvas.height;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GenericCanvasClass.prototype, "period", {
        /**
         * Returns the period (seconds) of this electrocardiogram
         * @return the period of this electrocardiogram
         */
        get: function () {
            return (SAMPLE_SIZE * this.width) / this.cellSize;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GenericCanvasClass.prototype, "time", {
        /**
         * Change time.
         */
        set: function (time) {
            this.configuration.TIME = time;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GenericCanvasClass.prototype, "amplitude", {
        /**
         * Change amplitude.
         */
        set: function (amplitude) {
            this.configuration.AMPLITUDE = amplitude;
        },
        enumerable: false,
        configurable: true
    });
    return GenericCanvasClass;
}());
export { GenericCanvasClass };
//# sourceMappingURL=GenericCanvasClass.js.map